import { render, staticRenderFns } from "./detail-delivery-qr.vue?vue&type=template&id=1ea1706a&"
import script from "./detail-delivery-qr.vue?vue&type=script&lang=js&"
export * from "./detail-delivery-qr.vue?vue&type=script&lang=js&"
import style0 from "./detail-delivery-qr.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports